import {injectable} from "inversify";
import chance from "@/modules/base/services/chance";
import Color from "colorjs.io";

@injectable()
export default class TeamColorGenerator {
  private randomColor(): string {
    return chance.pickone(
      Object.values(ColorValue[chance.randomEnum(ColorEnum)])
    );
  }

  public generate(minimumDistance: number = .7): { primary: string, secondary: string } {
    const primary = this.randomColor();
    let secondary;
    let diff = 0;

    do {
      secondary = this.randomColor();
      diff = (new Color(secondary)).contrast(new Color(primary), 'weber');
    } while (diff < 1);

    return {primary, secondary};
  }
}
